import type { ComparisonType} from "@@/shared/comparisons";
import { comparisonTypes } from "@@/shared/comparisons";
import type {
    IsoAndUnixTimestamp} from "@@/shared/date-time/iso-and-unix";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import type { Price} from "@@/shared/prices/price";
import { priceZodSchema } from "@@/shared/prices/price";
import type { Except } from "type-fest";
import { z } from "zod";
import type {
    FeeSourceOrdersFilterId} from "./fee-source-orders-filter-id";
import {
    feeSourceOrdersFilterIdFactory,
    feeSourceOrdersFilterIdZodSchema,
} from "./fee-source-orders-filter-id";

type FeeSourceOrdersFilterPrice = {
    readonly _id: FeeSourceOrdersFilterId;
    readonly _type: "FEE_SOURCE_ORDERS_FILTER";
    readonly _createdAt: IsoAndUnixTimestamp;
    readonly type: "PRICE";
    readonly comparison: ComparisonType;
    readonly orderPrice: Price; // todo: before or after discounts?
};

type Params = Except<
    FeeSourceOrdersFilterPrice,
    "_id" | "type" | "_type" | "_createdAt"
>;
const feeSourceOrdersFilterPriceFactory = (
    params: Params,
): FeeSourceOrdersFilterPrice => {
    return {
        ...params,
        _id: feeSourceOrdersFilterIdFactory(),
        _type: "FEE_SOURCE_ORDERS_FILTER",
        _createdAt: nowIsoAndUnix(),
        type: "PRICE",
    };
};

const feeSourceOrdersFilterPriceZodSchema: z.ZodSchema<FeeSourceOrdersFilterPrice> =
    z.object({
        _id: feeSourceOrdersFilterIdZodSchema,
        _type: z.literal("FEE_SOURCE_ORDERS_FILTER"),
        _createdAt: isoAndUnixZodSchema,
        type: z.literal("PRICE"),
        comparison: z.enum(comparisonTypes),
        orderPrice: priceZodSchema,
    });

export {
    feeSourceOrdersFilterPriceFactory,
    feeSourceOrdersFilterPriceZodSchema,
};
export type { FeeSourceOrdersFilterPrice };
